import { useBaseStore } from '@roc/feature-app-core';
import { getPlatformLoanRoutesConfig } from '../routes/platformLoanRoutesConfig';

export const usePlatformLoanRoutes = () => {
  const { globalStore } = useBaseStore();
  const { routeBasePath, routeBaseUrl } = globalStore;

  return {
    platformLoanRoutesConfig: getPlatformLoanRoutesConfig(routeBasePath, routeBaseUrl),
  };
};
